import Vue from 'vue'
import Router from 'vue-router'

const Home = resolve => require(['@/components/Home'], resolve);
const HomePage = resolve => require(['@/components/home/index'], resolve);
const OrganizationIndex = resolve => require(['@/components/organization/index'], resolve); // 组织机构导航页
const Organization = resolve => require(['@/components/organization/Organization'], resolve); // 组织机构
const Bylaws = resolve => require(['@/components/organization/Bylaws'], resolve); // 章程细则
const FileNotification = resolve => require(['@/components/organization/FileNotification'], resolve); // 文件通知
const MediaEditorial = resolve => require(['@/components/organization/MediaEditorial'], resolve); // 媒体社评
const Events = resolve => require(['@/components/organization/Events'], resolve); // 赛事动态
const EventReviewIndex = resolve => require(['@/components/eventReview/index'], resolve); // 赛事回顾导航页
const EventReview = resolve => require(['@/components/eventReview/EventReview'], resolve); // 赛事回顾
const InnovativeAchievements = resolve => require(['@/components/eventReview/InnovativeAchievements'], resolve); // 创新成果集
const CompetitionNewsletter = resolve => require(['@/components/eventReview/CompetitionNewsletter'], resolve); // 竞赛通讯
const CompetitionAchievementAward = resolve => require(['@/components/eventReview/CompetitionAchievementAward'], resolve); // 竞赛成果奖
const PreviousWorks = resolve => require(['@/components/eventReview/PreviousWorks'], resolve); // 历届作品
const EventNewsletter = resolve => require(['@/components/eventReview/EventNewsletter'], resolve); // 赛事简讯
const FiveOneProjects = resolve => require(['@/components/fiveOneProjects/FiveOneProjects'], resolve); // 五个一工程
const CompetitionList = resolve => require(['@/components/competitionList/CompetitionList'], resolve); // 大赛榜单
const Highlights = resolve => require(['@/components/highlights/Highlights'], resolve); // 大赛榜单
const DataDownload = resolve => require(['@/components/dataDownload/DataDownload'], resolve); // 资料下载
const SchoolCompetitionInfo = resolve => require(['@/components/organization/SchoolCompetitionInfo'], resolve); // 校赛发布
const ContactUs = resolve => require(['@/components/contactUs/ContactUs'], resolve); // 联系我们
const NewsDetail = resolve => require(['@/components/common/newsDetail'], resolve); // 新闻详情
const SignUp = resolve => require(['@/components/home/SignUp'], resolve); // 报名入口
const FillingInfo = resolve => require(['@/components/home/FillingInfo'], resolve); // 报名填报
const SearchInfo = resolve => require(['@/components/home/SearchInfo'], resolve); // 查询入口

Vue.use(Router)
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '',
          redirect: '/home',
        },
        {
          path: '/home',
          name: 'HomePage',
          component: HomePage,
        },
        {
          path: '/news',
          component: OrganizationIndex,
          children: [
            {
              path: '',
              redirect: '/news/organization',
            },
            {
              path: '/news/organization',
              name: 'Organization',
              component: Organization,
            },
            {
              path: '/news/bylaws',
              name: 'Bylaws',
              component: Bylaws,
            },
            {
              path: '/news/fileNotification',
              name: 'FileNotification',
              component: FileNotification,
            },
            {
              path: '/news/events',
              name: 'Events',
              component: Events,
            },
            {
              path: '/news/mediaEditorial',
              name: 'MediaEditorial',
              component: MediaEditorial,
            },
            {
              path: '/news/schoolCompetitionInfo',
              name: 'SchoolCompetitionInfo',
              component: SchoolCompetitionInfo,
            },
          ]
        },

        {
          path: '/half',
          component: EventReviewIndex,
          children: [
            {
              path: '',
              redirect: '/half/eventReview',
            },
            {
              path: '/half/eventReview',
              name: 'EventReview',
              component: EventReview,
            },
            {
              path: '/half/innovativeAchievements',
              name: 'InnovativeAchievements',
              component: InnovativeAchievements,
            },
            {
              path: '/half/competitionNewsletter',
              name: 'CompetitionNewsletter',
              component: CompetitionNewsletter,
            },
            {
              path: '/half/competitionAchievementAward',
              name: 'CompetitionAchievementAward',
              component: CompetitionAchievementAward,
            },
            {
              path: '/half/previousWorks',
              name: 'PreviousWorks',
              component: PreviousWorks,
            },
            {
              path: '/half/eventNewsletter',
              name: 'EventNewsletter',
              component: EventNewsletter,
            },
          ]
        },
        {
          path: '/fiveOneProjects',
          name: 'FiveOneProjects',
          component: FiveOneProjects,
        },
        {
          path: '/competitionList',
          name: 'CompetitionList',
          component: CompetitionList,
        },
        {
          path: '/highlights',
          name: 'Highlights',
          component: Highlights,
        },
        {
          path: '/dataDownload',
          name: 'DataDownload',
          component: DataDownload,
        },
        {
          path: '/contactUs',
          name: 'ContactUs',
          component: ContactUs,
        },
        {
          path: '/newsDetail',
          name: 'NewsDetail',
          component: NewsDetail,
        },
        {
          path: '/signUp',
          name: 'SignUp',
          component: SignUp,
        },
        {
          path: '/sillingInfo',
          name: 'FillingInfo',
          component: FillingInfo,
        },
        {
          path: '/searchInfo',
          name: 'SearchInfo',
          component: SearchInfo,
        },

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js